import { Reducer } from 'redux';
import {
    ORGANIZATION_MANAGER_DELETE_START,
    ORGANIZATION_MANAGER_DELETE_SUCCESS,
    ORGANIZATION_MANAGER_ERROR,
    ORGANIZATION_MANAGER_CLEAR_ERROR,
    ORGANIZATION_MANAGER_CLEAR_SUCCESS,
    ORGANIZATION_MANAGER_FETCH_START,
    ORGANIZATION_MANAGER_FETCH_SUCCESS,
    ORGANIZATION_MANAGER_RESET,
    ORGANIZATION_MANAGER_SAVE_START,
    ORGANIZATION_MANAGER_SAVE_SUCCESS,
    OrganizationManagerAction
} from 'actions/organizationManager/OrganizationManagerActionsTypes';
import { OrganizationManagerState, OrganizationManagerStatus } from './OrganizationManagersState';

const initialState: OrganizationManagerState = {
    organizationManagers: [],
    pagination: {
        currentPage: 1,
        prevPage: null,
        nextPage: null,
        size: 10,
        totalPages: 0,
        totalRecords: 0
    },
    status: OrganizationManagerStatus.Initial,
    loading: false
};

export const organizationManagersReducer: Reducer<OrganizationManagerState, OrganizationManagerAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ORGANIZATION_MANAGER_RESET:
            return {
                ...initialState
            };

        case ORGANIZATION_MANAGER_ERROR:
            return {
                ...state,
                loading: false,
                status: OrganizationManagerStatus.Error,
                error: action.payload.error
            };

        case ORGANIZATION_MANAGER_CLEAR_ERROR:
            return {
                ...state,
                status: OrganizationManagerStatus.Initial,
                error: undefined
            };

        case ORGANIZATION_MANAGER_CLEAR_SUCCESS:
            return {
                ...state,
                status: OrganizationManagerStatus.Initial,
                savedOrganizationManager: undefined
            };

        case ORGANIZATION_MANAGER_FETCH_START:
            return {
                ...state,
                loading: true,
                status: OrganizationManagerStatus.Fetching,
                error: undefined // Clear previous errors
            };

        case ORGANIZATION_MANAGER_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                status: OrganizationManagerStatus.FetchSuccess,
                // Always replace data for pagination (not infinite scroll)
                organizationManagers: action.payload.organizationManagers,
                pagination: action.payload.pagination
            };

        case ORGANIZATION_MANAGER_SAVE_START:
            return {
                ...state,
                loading: true,
                status: OrganizationManagerStatus.Saving,
                savedOrganizationManager: undefined,
                error: undefined // Clear previous errors
            };

        case ORGANIZATION_MANAGER_SAVE_SUCCESS:
            let organizationManagers = [...state.organizationManagers];

            if (organizationManagers.some(om => om.id === action.payload.organizationManager.id)) {
                organizationManagers = organizationManagers.map(om =>
                    om.id === action.payload.organizationManager.id ? { ...action.payload.organizationManager } : om
                );
            } else {
                organizationManagers = [...organizationManagers, { ...action.payload.organizationManager }];
            }

            // Sort by name (last_name, then first_name)
            const sortedOrganizationManagers = organizationManagers.sort((a, b) => {
                const nameA = `${a.lastName || ''} ${a.firstName || ''}`.trim();
                const nameB = `${b.lastName || ''} ${b.firstName || ''}`.trim();
                return nameA.localeCompare(nameB);
            });

            return {
                ...state,
                loading: false,
                status: OrganizationManagerStatus.SaveSuccess,
                organizationManagers: sortedOrganizationManagers,
                savedOrganizationManager: { ...action.payload.organizationManager }
            };

        case ORGANIZATION_MANAGER_DELETE_START:
            return {
                ...state,
                loading: true,
                status: OrganizationManagerStatus.Deleting
            };

        case ORGANIZATION_MANAGER_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: OrganizationManagerStatus.DeleteSuccess,
                // Filter by membership id - `id` is the person, not the membership
                organizationManagers: state.organizationManagers.filter(
                    om => om.organizationManagerId !== action.payload.organizationManagerId
                )
            };

        default:
            return state;
    }
};

export default organizationManagersReducer;
